import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesContactAbout from './components/FeaturesContactAbout';
import CommentsUpdatesSection from './components/CommentsUpdatesSection';
import MediaTopicsSection from './components/MediaTopicsSection';
import CarouselSection from './components/CarouselSection';
import AppCardsSection from './components/AppCardsSection';
import IndexFaqRanking from './components/IndexFaqRanking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FeaturesContactAbout />
        <CommentsUpdatesSection />
        <MediaTopicsSection />
        <CarouselSection />
        <AppCardsSection />
        <IndexFaqRanking />
      </main>
      <Footer />
    </div>
  );
}